module.exports = require("npm:selector-set@1.1.2/selector-set.js");